<div *ngIf="!fileExplorerService.IsListMode" class="tile-view">
  <ul class="tile-view-list"
      cdkDropList
      [cdkDropListDisabled]="!canEdit"
      (cdkDropListDropped)="drop($event)"
      [cdkDropListData]="fileExplorerService.selected.children">
    <li *ngFor="let item of fileExplorerService.selected.children"
        cdkDrag
        (cdkDragStarted)="dragStarted($event)"
        (cdkDragEnded)="dragEnded($event)"
        (dblclick)="fileExplorerService.setSelected(item)"
        (mouseenter)="fileExplorerService.setHoveredItem(item)"
        (mouseleave)="fileExplorerService.clearHoveredItem()"
        (contextmenu)="openContextMenu($event, item)"
        [cdkDragData]="item">
      <a [title]="item.name">
        <span class="item-icon" [ngClass]="item.cssClass"></span>
        <span class="item-text">{{item.name}}</span>
      </a>
    </li>
  </ul>
</div>

<div *ngIf="fileExplorerService.IsListMode" class="grid-view-container">
  <table class="table table-hover grid-view">
    <thead>
      <tr>
        <th width="20%"></th>
        <th width="50%">{{ 'Common.SearchColumnsAndDetailsFields.Name' | translate }}</th>
        <th width="30%">{{ 'Common.SearchColumnsAndDetailsFields.Date' | translate }}</th>
      </tr>
    </thead>
    <tbody cdkDropList
           [cdkDropListDisabled]="!canEdit"
           (cdkDropListDropped)="drop($event)"
           [cdkDropListData]="fileExplorerService.selected.children">

      <tr *ngFor="let item of fileExplorerService.selected.children"
          cdkDrag
          (cdkDragStarted)="dragStarted($event)"
          (cdkDragEnded)="dragEnded($event)"
          (dblclick)="fileExplorerService.setSelected(item)"
          (mouseenter)="fileExplorerService.setHoveredItem(item)"
          (mouseleave)="fileExplorerService.clearHoveredItem()"
          (contextmenu)="openContextMenu($event, item)"
          [cdkDragData]="item">
        <td><span class="item-icon" [ngClass]="item.cssClass"></span></td>
        <td><span class="item-text">{{item.name}}</span></td>
        <td><span class="item-text">{{item.createdDate | date}}</span></td>
      </tr>
    </tbody>
  </table>
</div>

<div class="cdk-context-menu-backdrop" *ngIf="contextMenuItem" (click)="closeContextMenu()"></div>

<div #contextMenu="cdkMenu"
     class="context-menu"
     cdkMenu
     *ngIf="contextMenuItem"
     [style.left]="contextMenuPosition.x"
     [style.top]="contextMenuPosition.y">

  <ng-container *ngIf="contextMenuItem?.type === 'file'">
    <button cdkMenuItem (click)="download(contextMenuItem)">
      <i class="fa fa-cloud-download"></i> {{ 'Screens.FileExplorer.Actions.Download' | translate }}
    </button>
  </ng-container>

  <ng-container *ngIf="canEdit">
    <button cdkMenuItem (click)="openRenamePopup(contextMenuItem)">
      <i class="fa fa-edit"></i> {{ 'Screens.FileExplorer.Actions.Rename' | translate }}
    </button>

    <button *ngIf="specialActionPermissions.allowToDeletePatientDocuments.canExecute"
            cdkMenuItem
            (click)="delete(contextMenuItem)">
      <i class="fa fa-trash"></i> {{ 'Screens.FileExplorer.Actions.Delete' | translate }}
    </button>
  </ng-container>
</div>

<ng-template #renameModalTemplate let-data="data" let-form="form">
  <div class="row" [dynamicFormProvider]="form">
    <div class="col-sm-9" *ngIf="form">
      <waf-text-input #newNameTextInput
                      [fileNameAlreadyExistsValidator]="{name: data.nameCurrent, isFile: data.isFile}"
                      name="newName"
                      fileNameContainSpecificSymbolsValidator
                      [label]="'Screens.FileExplorer.Fields.NewName' | translate"
                      [(ngModel)]="data.nameNew"
                      [placeholder]="'Screens.FileExplorer.Fields.NewName' | translate"
                      required
                      [maxLength]="100"></waf-text-input>
    </div>
  </div>
</ng-template>
